export enum SortOption {
  MOST_CLAIMED = 'MOST_CLAIMED',
  LOW_TO_HIGH = 'LOW_TO_HIGH',
  HIGH_TO_LOW = 'HIGH_TO_LOW',
  A_Z = 'AZ',
  Z_A = 'ZA',
}
